import React from "react";
import Select from "./Select";
import { graphql } from "react-apollo";
import { gql } from "apollo-boost";

const SalespersonSelect = ({
  franchiseId,
  data,
  placeholder,
  ...otherProps
}) => {
  let status, salespeople;

  if (!data || !franchiseId) {
    status = "Please select a franchise.";
  } else {
    if (data.loading) status = "Loading...";
    else if (data.error) status = "Could not load salespeople.";
    else {
      if (!data.franchiseMemberships.length)
        status = "There are no salespeople.";
      else salespeople = data.franchiseMemberships.map(fm => fm.user);
    }
  }

  return (
    <Select
      {...otherProps}
      options={salespeople}
      placeholder={status || placeholder}
      valueKey="id"
      labelKey="name"
    />
  );
};

export const SalespeopleQuery = gql`
  query SalespeopleQuery($franchiseId: ID) {
    franchiseMemberships(franchiseId: $franchiseId, type: "salesperson") {
      id
      trackAsSalesperson
      user {
        id
        name
        email
        phone
        role
      }
    }
  }
`;

export default graphql(SalespeopleQuery, {
  options: ({ franchiseId }) => ({
    variables: { franchiseId },
    fetchPolicy: "network-only"
  }),
  skip: ({ franchiseId }) => !franchiseId
})(SalespersonSelect);



// WEBPACK FOOTER //
// ./src/components/forms/SalespersonSelect.js